import React, { useState, useEffect, useCallback } from 'react'; // Added useCallback
import { useParams } from 'react-router-dom';
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';
import Footer from '../components/Footer';

// Function to create a URL friendly slug from the title (from YayindanSection)
const createSlug = (title) => {
  return title
    .toLowerCase()
    .replace(/ğ/g, 'g')
    .replace(/ü/g, 'u')
    .replace(/ş/g, 's')
    .replace(/ı/g, 'i')
    .replace(/ö/g, 'o')
    .replace(/ç/g, 'c')
    .replace(/[^a-z0-9\s-]/g, '')
    .replace(/\s+/g, '-')
    .replace(/-+/g, '-');
};

const projectsData = [
  {
    id: 1,
    title: 'Seoul - Asiana Airlines Hangar',
    location: 'Incheon Havalimanı',
    category: 'airport',
    imageUrl: '/collect/545-asiana-airlines-01.jpg',
    // Add multiple images for carousel if needed
    galleryImages: [
      '/collect/asiana/959-project-asiana-1724.jpg',
      '/collect/asiana/959-project-asiana-1743.jpg',
      '/collect/asiana/959-project-asiana-1747.jpg',
      '/collect/asiana/959-project-asiana-8606.jpg',
    ],
    description: {
      section1: {
        title: 'Zorluklar',
        // Markdown formatında metin: Satır atlamak için boş satır bırakın veya satır sonuna iki boşluk ekleyin. Maddeleme için * kullanın.
        text: `Dünyanın en ünlü tasarım gruplarından Schlaich Bergermann und Partner tarafından tasarlanan dev hangar binası projesinde birçok önemli güçlük vardı.
* Bölge, tayfun kuşağı içindeydi.
* Binanın cephesi tayfuna açık bulunuyordu.
* Proje dünyanın önemli deprem kuşaklarından birinde olduğundan binanın deprem dayanımının çok yüksek olması gerekiyordu.`,
      },
      section2: {
        title: 'Proje özellikleri',
        text: `9.5 metreye kadar serbest boyda üretilebilen Panolux, hafifliği ve dayanıklılığıyla konut dışı projelerde iç ve dış kullanımda geniş olanaklar sunar.

Kurumsal projeler için tüm Pantone® ve RAL® renklerde üretilebilen Panolux;
* gar, otogar, metro vb. ulaşım terminallerinde,
* tersane, iskele ve denizcilik terminallerinde,
* banka, AVM, otel ve iş merkezlerinde,
* sanayi tesislerinde ve çok geniş açıklıklı kapı projelerinde kullanılabilir.`,
      },
      section3: {
        title: 'Panolux ile dev kapılar',
        text: `Konut projelerinde tasarımcılara çok büyük esneklik sağlayan Panolux, yapıları ışıkla çok kolay buluşturan bir malzemedir.
Kolay işlenebilen ve bina yükünü artırmayan Panolux, müstakil ve çok katlı konut projelerinde;
* kış bahçesi, limonluk vb. hacimlerde,
* iç seperasyonlarda,
* ışık girmesi istenen duvar, tavan ve çatı uygulamalarında kullanılabilir.`,
      },
    },
  },
  // ... (Add description and galleryImages for other projects similarly)
  {
    id: 2,
    title: 'İstanbul - THY Hangarları',
    location: 'Sabiha Gökçen Havalimanı',
    category: 'airport',
    imageUrl: '/collect/545-sabiha-gokcen-012.jpg',
    galleryImages: [
      `/collect/sabiha/959-panolux-sabiha-gokcen-0013.jpg`,
      `/collect/sabiha/959-panolux-sabiha-gokcen-0055.jpg`,
      `/collect/sabiha/959-panolux-sabiha-gokcen-0076.jpg`,
      `/collect/sabiha/959-panolux-sabiha-gokcen-0088.jpg`
    ],
    description: {
      "section1": {
        "title": "Proje Özellikleri",
        "text": "Dünya uçak bakım merkezleri arasında önemli bir yere sahip olmak üzere başlatılan **HABOM projesi**, THY'nin çok önemli yatırımları arasında yer alıyor. Proje, dünya uçak motor devi **Pratt&Whitney** ile ortak motor merkezi yatırımını da kapsıyor."
      },
      "section2": {
        "title": "Bazı Rakamlar",
        "text": `
* İnşaat alanı **20 hektarı** kaplıyor.
* Toplam hangar alanı **364.000 m²**.
* Hangarlarda uçak bakımının yanı sıra avionik, iniş takımı, kabin ve diğer komponent atölyeleri de bulunuyor.
* İki hangar aynı anda **11 dar, 3 geniş gövdeli uçak** alabiliyor.`
      },
      "section3": {
        "title": "Dev tesisin kapıları Panolux",
        "text": "Dev tesisin kapıları **Panolux** ile inşa edildi. **8 Mart 2013**'te ilk uçağı kabul eden tesisin **yüksek güvenlikli dev hangar kapıları**, üstün teknik özellikler taşıyan Panolux ile inşa edildi."
      }
    },
  },
  {
    id: 3,
    title: 'İstanbul - İş Jeti Hangarları',
    location: 'Sabiha Gökçen Havalimanı',
    category: 'airport',
    imageUrl: '/collect/540-sabiha-gokcen-is-jeti-business-jet-hangar-4955.jpg',
    galleryImages: [
      `/collect/gokcen/959-slider-sabiha-gokcen-is-jeti-business-jet-hangar-ic-interior-01.jpg`,
      `/collect/gokcen/959-slider-sabiha-gokcen-is-jeti-business-jet-hangar-4979.jpg`,
      `/collect/gokcen/959-slider-sabiha-gokcen-is-jeti-business-jet-hangar-4955.jpg`,
      `/collect/gokcen/959-slider-sabiha-gokcen-is-jeti-business-jet-hangar-2505.jpg`
    ],
    description: {
      section1: {
        title: 'İş Jeti Hangarlarında Panolux Çözümleri',
        text: 'Özel jet kiralamada 2015 ortasından itibaren Avrupa, Asya ve Kuzey Afrika’nın merkezi haline gelen İstanbul’da artan hangar ihtiyacı **Sabiha Gökçen iş jeti** hangarları ile karşılanıyor.',
      },
      section2: {
        title: 'Bazı Rakamlar',
        text: `
* Toplam hangar alanı 10.000 m²
* Hangarlar aynı anda 11 orta gövdeli iş jetini barındırabiliyor.
* Hangarlarda bakım hizmetlerinin yanısıra özel yolcu salonları da bulunuyor.`,
      },
      section3: {
        title: 'Bakım Kolaylığı',
        text: `Dünya iş jeti pazarında ilk sıralara yerleşen İstanbul’un bu alandaki en önemli yatırımlarından birinde **havacılık ve güvenlik açısından** üstün teknik özellikler taşıyan **Panolux** kullanıldı.`,
      },
    },
  },
  {
    id: 4,
    title: 'Mönchengladbach - Yeni Hangar',
    location: 'Mönchengladbach Havaalanı',
    category: 'airport',
    imageUrl: '/collect/545-schmitter-tore-monchengladbach-hangar-door-kapi-6508.jpg',
    galleryImages: [
      '/collect/545-schmitter-tore-monchengladbach-hangar-door-kapi-6508.jpg',
    ],
    description: {
      section1: {
        title: 'Mönchengladbach Yeni Hangar Projesi',
        text: 'Mönchengladbach Havaalanı\'ndaki yeni hangar projesinde Panolux panelleri, hızlı kurulum ve yüksek performans sağlamıştır.',
      },
      section2: {
        title: 'Yapısal Entegrasyon',
        text: 'Paneller, hangar kapıları ve cephe sistemleriyle sorunsuz bir şekilde entegre edilmiş, projenin genel estetiğine katkıda bulunmuştur.',
      },
      section3: {
        title: 'Çevre Dostu Çözümler',
        text: 'Panolux\'un çevre dostu özellikleri, bu projede sürdürülebilir bir yapı oluşturulmasına yardımcı olmuştur.',
      },
    },
  },
  {
    id: 5,
    title: 'Chambley-Bussières - Planet Air Hangarları',
    location: 'Chambley-Bussières Hava Üssü',
    category: 'airport',
    imageUrl: '/collect/545-chambley-4403.jpg',
    galleryImages: [
      '/collect/545-chambley-4403.jpg',
    ],
    description: {
      section1: {
        title: 'Planet Air Hangarlarında Panolux',
        text: 'Chambley-Bussières Hava Üssü\'nde yer alan Planet Air Hangarları, Panolux panelleri sayesinde modern ve işlevsel bir yapıya kavuşmuştur.',
      },
      section2: {
        title: 'Mimari Esneklik',
        text: 'Panolux, mimarlara geniş tasarım esnekliği sunarak projenin özgün ihtiyaçlarına cevap vermiştir.',
      },
      section3: {
        title: 'Uygulama Kolaylığı',
        text: 'Panellerin hafifliği ve montaj kolaylığı, projenin zamanında ve bütçe dahilinde tamamlanmasına katkı sağlamıştır.',
      },
    },
  },
  {
    id: 6,
    title: 'Tersane',
    location: 'Türkmen Marine - Bodrum',
    category: 'industrial',
    imageUrl: '/collect/545-panolux-turkmen-marine-5176.jpg',
    galleryImages: [
      '/collect/545-panolux-turkmen-marine-5176.jpg',
    ],
    description: {
      section1: {},
      section2: {
        title: 'Proje özellikleri',
        text: `2004’ten beri inovatif yat tasarımlarıyla tanınan lider yat üreticilerinden Türkmen Marine, 2012 yılında inşa edilen yeni tersanesinde Panolux’ü tercih etti.

* Tersane alanı 10.000 m² dir.`,
      },
      section3: {},
    },
  },
  {
    id: 7,
    title: 'Endüstriyel tesis',
    location: 'Antrepo kapıları',
    category: 'industrial',
    imageUrl: '/collect/545-panolux-764.jpg',
    galleryImages: [
      '/collect/fibrosan/959-panolux-fibrosan-2220.jpg',
      '/collect/fibrosan/959-panolux-fibrosan-2229.jpg',
      '/collect/fibrosan/959-panolux-fibrosan-2252-2255.jpg',
      '/collect/fibrosan/959-panolux-fibrosan-2258-2266.jpg',
    ],
    description: {
      section1: {},
      section2: {
        title: 'Proje özellikleri',
        text: `Kapalı alanda, çok aydınlık olmayan günlerde bile gün ışığından en iyi şekilde yararlanmayı sağlayan Panolux, her türlü uzunluk veya yüksekliği monoblok olarak geçme olanağı da veriyor.`,
      },
      section3: {},
    },
  },
  {
    id: 8,
    title: 'Konut',
    location: 'Işık geçiren tavanlar',
    category: 'residential',
    imageUrl: '/collect/545-panolux-ceiling-01.jpg',
    galleryImages: [
      '/collect/545-panolux-ceiling-01.jpg',
    ],
    description: {
      section1: {
        title: 'Konutlarda Işık Geçiren Tavanlar',
        text: 'Panolux, konut projelerinde ışık geçiren tavan uygulamalarıyla doğal aydınlatmayı artırır ve modern bir estetik sunar. Ferah yaşam alanları yaratmak için idealdir.',
      },
      section2: {
        title: 'Tasarım ve Fonksiyonellik',
        text: 'Paneller, konutların iç mekanlarına sofistike bir dokunuş katarken, aynı zamanda enerji verimliliği sağlar.',
      },
      section3: {
        title: 'Kolay Uygulama ve Bakım',
        text: 'Panolux\'un hafifliği ve kolay işlenebilirliği, konut projelerinde uygulama sürecini basitleştirir ve uzun ömürlü kullanım sunar.',
      },
    },
  },
  {
    id: 9,
    title: 'Ofis',
    location: 'Işık geçiren seperasyonlar',
    category: 'office',
    imageUrl: '/collect/545-panolux-6800.jpg',
    galleryImages: [
      '/collect/545-panolux-6800.jpg',
    ],
    description: {
      section1: {
        title: 'Ofislerde Işık Geçiren Seperasyonlar',
        text: 'Ofis ortamlarında Panolux, ışık geçiren seperasyonlar ile açık ve aydınlık çalışma alanları yaratır. Çalışanların verimliliğini artıran modern ve ferah bir ortam sunar.',
      },
      section2: {
        title: 'Esnek Ofis Tasarımı',
        text: 'Paneller, ofislerin değişen ihtiyaçlarına göre kolayca uyarlanabilir ve yeniden yapılandırılabilir çözümler sunar.',
      },
      section3: {
        title: 'Akustik ve Görsel Konfor',
        text: 'Panolux, akustik yalıtım özellikleri sayesinde sessiz bir çalışma ortamı sağlarken, şeffaf yapısıyla görsel olarak da rahat bir ortam sunar.',
      },
    },
  },
];


function ProjectDetailPage() {
  const { slug } = useParams();
  const [project, setProject] = useState(null);
  const [currentIndex, setCurrentIndex] = useState(0);
  const intervalTime = 3000; // Time in milliseconds for automatic slide transition

  // Determine the images to use for the carousel
  const images = project?.galleryImages?.length > 0
    ? project.galleryImages
    : [project?.imageUrl || 'https://placehold.co/600x400/CCCCCC/333333?text=Image+Not+Available'];

  // Memoized goToNext function
  const goToNext = useCallback(() => {
    setCurrentIndex((prevIndex) => {
      const isLastSlide = prevIndex === images.length - 1;
      return isLastSlide ? 0 : prevIndex + 1;
    });
  }, [images.length]); // Dependency: images.length to recalculate if image count changes

  // Memoized goToPrevious function
  const goToPrevious = useCallback(() => {
    setCurrentIndex((prevIndex) => {
      const isFirstSlide = prevIndex === 0;
      return isFirstSlide ? images.length - 1 : prevIndex - 1;
    });
  }, [images.length]); // Dependency: images.length

  // Effect to load project data and reset carousel index
  useEffect(() => {
    const foundProject = projectsData.find(p => createSlug(p.title) === slug);
    if (foundProject) {
      setProject(foundProject);
      // Reset index to 0 when a new project is loaded
      setCurrentIndex(0);
    } else {
      console.error('Project not found for slug:', slug);
      setProject(null);
    }
  }, [slug]); // Rerun when slug changes

  // Effect for automatic slide transitions
  useEffect(() => {
    // Only start interval if there's a project and more than one image
    if (project && images.length > 1) {
      const intervalId = setInterval(() => {
        goToNext();
      }, intervalTime);

      return () => clearInterval(intervalId); // Cleanup on unmount or re-render
    }
    return undefined; // Return undefined if no interval is set
  }, [goToNext, images.length, project, intervalTime]); // Dependencies for auto-slide

  if (!project) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <p className="text-gray-600 text-xl">Proje bulunamadı...</p>
      </div>
    );
  }

  return (
    <>
      <div className="font-light antialiased min-h-screen flex flex-col items-center bg-white p-8">
        {/* Project Title */}
        <h1 className="text-4xl font-light text-center text-gray-900 mb-8 mt-16">
          {project.title}
        </h1>
        <p className="text-xl text-gray-700 text-center mb-12">
          {project.location}
        </p>

        {/* Slider Carousel */}
        <div className="relative w-full max-w-4xl h-[34rem] overflow-hidden rounded-lg shadow-lg mb-12">
          {images.map((image, index) => (
            <img
              key={index}
              src={image}
              alt={`${project.title} - Slide ${index + 1}`}
              className={`absolute top-0 left-0 w-full h-full object-fix transition-all duration-700 ease-in-out
                ${index === currentIndex ? 'opacity-100 scale-100' : 'opacity-0 scale-105'}`}
              onError={(e) => {
                e.target.onerror = null;
                e.target.src = `https://placehold.co/600x400/CCCCCC/333333?text=Image+Error`;
              }}
            />
          ))}

          {/* Left Arrow */}
          {images.length > 1 && (
            <>
              <button
                onClick={goToPrevious}
                className="absolute top-1/2 left-0 transform -translate-y-1/2 bg-white bg-opacity-50 text-gray-800 p-3 hover:bg-opacity-75 focus:outline-none z-10"
              >
                &lt;
              </button>

              {/* Right Arrow */}
              <button
                onClick={goToNext}
                className="absolute top-1/2 right-0 transform -translate-y-1/2 bg-white bg-opacity-50 text-gray-800 p-3 hover:bg-opacity-75 focus:outline-none z-10"
              >
                &gt;
              </button>
            </>
          )}
        </div>

        {/* Three-Column Paragraph Structure */}
        <div className="w-full max-w-4xl grid grid-cols-1 md:grid-cols-3 gap-8 mb-8">
          {project.description && (
            <>
              <div className="">
                <h3 className="text-md text-center font-light text-gray-800 mb-3">
                  {project.description.section1?.title}
                </h3>
                {/* ReactMarkdown bileşenini kullanın */}
                <div className="prose prose-sm max-w-none text-gray-700 leading-relaxed text-left"> {/* Tailwind'in 'prose' sınıfını kullanın */}
                  <ReactMarkdown remarkPlugins={[remarkGfm]}>
                    {project.description.section1?.text}
                  </ReactMarkdown>
                </div>
              </div>

              <div className="">
                <h3 className="text-md text-center font-light text-gray-800 mb-3">
                  {project.description.section2?.title}
                </h3>
                <div className="prose prose-sm max-w-none text-gray-700 leading-relaxed text-left">
                  <ReactMarkdown remarkPlugins={[remarkGfm]}>
                    {project.description.section2?.text}
                  </ReactMarkdown>
                </div>
              </div>

              <div className="">
                <h3 className="text-md text-center font-light text-gray-800 mb-3">
                  {project.description.section3?.title}
                </h3>
                <div className="prose prose-sm max-w-none text-gray-700 leading-relaxed text-left">
                  <ReactMarkdown remarkPlugins={[remarkGfm]}>
                    {project.description.section3?.text}
                  </ReactMarkdown>
                </div>
              </div>
            </>
          )}
        </div>

        <p className="mt-8 text-lg text-gray-600 text-center">
          Bu proje hakkında daha fazla bilgi almak için bizimle iletişime geçin.
        </p>
      </div>
      <Footer />
    </>
  );
}

export default ProjectDetailPage;